<ion-card class="mx-4 mb-0 shadow-none mt-4 ripple-parent rounded-rectangle" [ngClass]="{'ion-activatable': cardIcon}" color="light">
  <ion-ripple-effect></ion-ripple-effect>
  <ion-card-header *ngIf="cardTitle" class="pb-2">
    <ion-card-title class="flex items-center">
      <h2 class="text-lg text-gray-500 mt-2">{{ cardTitle }}</h2>
      <ion-icon *ngIf="cardIcon" [name]="cardIcon" class="ml-auto text-xl text-gray-500"></ion-icon>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content [class]="contentClasses">
    <ng-content></ng-content>
  </ion-card-content>
</ion-card>
